<form [formGroup]="updateQueryForm" novalidate (ngSubmit)="update()">
  <section class="sh-dialog__content">
    <p>{{ "components.saved-queries.update-confirm-dialog.message" | translate }}</p>

    @if (isShared) {
      <sh-notification
        [message]="'components.saved-queries.update-confirm-dialog.shared-warning' | translate"
        icon="group"
        [type]="NotificationType.Warning"
      ></sh-notification>
    }

    <sh-form-text-input
      id="update-query-name"
      [label]="'components.saved-queries.new-saved-query-dialog.controls.name.label' | translate"
      [control]="nameControl"
      [errorMsg]="nameControl.getError('message') || 'form.error.required-field' | translate"
      [errorResponse]="ErrorResponse.TOUCHED"
    >
    </sh-form-text-input>
    <sh-form-multi-select
      id="update-query-groups"
      [label]="'components.saved-queries.new-saved-query-dialog.controls.groups.label' | translate"
      [options]="groups$ | async"
      [control]="groupsControl"
      [multiple]="true"
      [multipleSelectedMsg]="'components.saved-queries.new-saved-query-dialog.controls.groups.multiple-selected' | translate"
      [listCappedMsg]="'components.saved-queries.new-saved-query-dialog.controls.groups.capped' | translate"
      [inOverflownContainer]="true"
    ></sh-form-multi-select>
  </section>
  <footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
      <button class="sh-button sh-action-group__item" type="submit" (click)="update()" [disabled]="!(canUpdate$ | async)">
        {{ "components.saved-queries.actions.update" | translate }} {{ (updateLoading$ | async) ? "..." : "" }}
      </button>
      <button class="sh-button--secondary sh-action-group__item" type="button" (click)="close()">
        {{ "actions.common.cancel" | translate }}
      </button>
    </div>
  </footer>
</form>
